import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { NEW_RELEASES } from '@/mocks/anime';

export default function NewReleases() {
  return (
    <section id="new" className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <div className="pointer-events-none absolute right-[-6rem] top-16 h-64 w-64 rounded-full bg-secondary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute left-[-6rem] bottom-10 h-64 w-64 rounded-full bg-accent-100/70 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionTitle
            align="left"
            eyebrow="每周更新"
            title="新番连载情报站"
            desc="锁定你追的每一部新番，更新状态、更新时间一览无余，准时守候不错过任何一集。"
          />
          <Reveal>
            <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100/70 px-4 py-2 text-xs text-foreground-600">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-70"></span>
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-500"></span>
              </span>
              本周更新 12 部
            </div>
          </Reveal>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-14 md:gap-6">
          {NEW_RELEASES.map((item, i) => (
            <Reveal key={item.id} delay={i * 60}>
              <article className="group flex gap-4 rounded-2xl border border-background-200 bg-background-100/50 p-4 transition-all hover:-translate-y-1 hover:border-accent-300 hover:bg-background-50">
                <div className="relative h-40 w-28 shrink-0 overflow-hidden rounded-xl md:h-44 md:w-32">
                  <img
                    src={item.image}
                    alt={`${item.title} 新番封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-1.5 top-1.5 rounded-md bg-black/60 px-2 py-0.5 text-[10px] font-semibold text-background-50 backdrop-blur">
                    {item.season}
                  </span>
                </div>
                <div className="flex flex-1 flex-col py-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-heading text-base text-foreground-950">{item.title}</h3>
                    <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-semibold text-accent-700 whitespace-nowrap">
                      {item.status}
                    </span>
                  </div>
                  <p className="mt-2 flex-1 text-xs leading-5 text-foreground-600">{item.desc}</p>
                  <a href="#guide" className="mt-3 inline-flex w-fit items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700">
                    追更指南
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}